import { connect } from 'react-redux';
import StudentBook from '../../../views/Student/report/StudentBook.student.view';

export default connect(null, null)(StudentBook);
